//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex'
import { Cascader } from 'element-ui'
import formWrapper from '../../components/pc/formWrapper'
import formInput from '../../components/pc/formInput'
import formVCode from '../../components/pc/formVCode'
import { isEmpty } from 'lodash'

const buildAreaOptionList = (data = []) => {
  return data.map(el => {
    return {
      value: el.areaId,
      label: el.areaName,
      children: el.childrenNum > 0 ? [] : null
    }
  })
}

export default {
  components: {
    [Cascader.name]: Cascader,
    formWrapper,
    formInput,
    formVCode
  },
  async created () {
    this.$wisLoading(true)
    let res = await this.areaSubAreas({ parentId: -1 })
    this.areaOptionList = buildAreaOptionList(res.data)
    this.$wisLoading(false)
  },
  async mounted () {
    window.scrollTo(0, 0)
  },
  data () {
    return {
      isEmpty,
      saError: false,
      areaOptionList: [],
      form: {
        schoolName: '',
        selectedArea: [],
        contactUsername: '',
        mobile: '',
        smsCode: '',
        qq: '',
        email: ''
      }
    }
  },
  computed: {
    ...mapState('common', []),
    ...mapGetters('common', []),

    showAreaErrorFlag () {
      return this.saError && isEmpty(this.form.selectedArea)
    },
    allAreaList () {
      let iterator = (array = []) => {
        let result = [...array]
        array.forEach(el => {
          if (el.children) result = [...result, ...el.children]
        })
        return result
      }
      return iterator(this.areaOptionList)
    }
  },
  watch: {
    'form.selectedArea' (v) {
      this.saError = true
    }
  },
  filters: {},
  methods: {
    ...mapActions('area', ['areaSubAreas']),
    ...mapActions('website', ['websiteSchoolApplyTrial']),

    async handleItemChange (v = []) {
      if (v.length < 1) return
      let lastVal = v.slice(-1)[0]
      let index = this.allAreaList.map(el => el.value).indexOf(lastVal)
      let filterData = this.allAreaList[index]
      if (filterData.children && filterData.children.length === 0) {
        let res = await this.areaSubAreas({ parentId: lastVal })
        filterData.children = buildAreaOptionList(res.data)
      }
    },
    async submit () {
      this.saError = true
      let formInputDomList = this.$children[0].$children.filter(el => /(FormInput|FormVCode)/g.test(el.$vnode.tag))
      if (formInputDomList.map(el => el.validate()).indexOf(false) > -1 || this.showAreaErrorFlag) return
      this.$wisLoading(true)
      let params = { ...this.form }
      params.provinceId = params.selectedArea[0]
      params.cityId = params.selectedArea[1]
      params.districtId = params.selectedArea[2]
      delete params.selectedArea
      await this.websiteSchoolApplyTrial(params)
      this.$refs.vcodeDom.clear()
      this.$wisLoading(false)
      this.$message({
        message: '提交成功，我们工作人员会主动联系您',
        type: 'success',
        duration: 10000,
        showClose: true
      })
      this.$router.push({
        path: '/'
      })
    }
  }
}
